import * as z from "zod";
import { mutator } from "./mutator";

export const setConnectorWebhookSecretSchema = z.object({
  connectorId: z.string(),
  secret: z.string().min(16),
});

export const setConnectorWebhookSecret = mutator({
  redactKeys: ["secret"],
  schema: setConnectorWebhookSecretSchema,
  resolve: {
    connector: { kind: "connectedApp", from: "connectorId" },
  },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.connector.id,
    },
  ],
  fn: async ({ tx, args }) => {
    await tx.mutate.connectedApps.update({
      id: args.connector.id,
      configuration: {
        ...args.connector.configuration,
        webhookSecretSetAt: String(Date.now()),
      },
    });
  },
});
